import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  type ButtonStyleOverrides,
} from "@newsela/angelou";

const { textXSObj } = typographyStyles;

const neutral25 = constants.colors.ui.neutral[25];
const uiNeutral50 = constants.colors.ui.neutral[50];
const neutral100 = constants.colors.ui.neutral[100];
const uiNeutral500 = constants.colors.ui.neutral[500];
const neutral700 = constants.colors.ui.neutral[700];
const uiCore700 = constants.colors.ui.core[700];

export const cardActionsContainerCss: CSSObject = {
  display: "flex",
  justifyContent: "center",
  position: "relative",
  alignItems: "center",
  flexWrap: "wrap",
  paddingTop: "4px",
  borderTop: `1px solid ${uiNeutral50}`,
  zIndex: 2,
};

export const linkCss = {
  root: {
    padding: "8px",
    textDecoration: "none",
    color: uiCore700,
  },
};

export const addToAssignmentButtonCss: ButtonStyleOverrides<CSSObject> = {
  root: {
    padding: "8px",
    color: constants.colors.ui.core[700],
  },
};

export const textCss: CSSObject = {
  margin: 0,
};

export const contentCardGradeAndLexileCss: CSSObject = {
  ...textXSObj,
  color: uiNeutral500,
  padding: "6px 0",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
};

export const contentCardTagsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  listStyle: "none",
  padding: 0,

  "&&": {
    marginBottom: "6px",
  },
};

export const contentCardTagCss: CSSObject = {
  ...textXSObj,
  minWidth: "100%",
  textAlign: "center",
  padding: "4px 8px",
  borderRadius: "20px",
  color: neutral700,
  border: `0.5px solid ${neutral100}`,
  background: neutral25,
  margin: "2px 0",
};

export const contentSettingsModeCss = {
  zIndex: 1,
  marginLeft: 0,
  width: "100%",
  padding: "12px 0",
};
